import { timelineNodes } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

const dotStyles: Record<string, string> = {
  normal: "bg-background-400 ring-4 ring-background-100",
  key: "bg-primary-500 ring-4 ring-primary-100",
  turning: "bg-accent-500 ring-4 ring-accent-100",
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[340px_1fr] lg:gap-16">
          <div className="self-start lg:sticky lg:top-28">
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">TIMELINE</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              灵灵黑料时间线大合集
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              把零散的信息按发生顺序排好，从最早的那条动态一路看到热度回落。每个节点都标了它属于哪个阶段，方便你对照着看。
            </p>

            <div className="mt-6 rounded-lg border border-accent-300 bg-accent-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className="ri-flashlight-line"></i>
                </span>
                <span className="font-heading text-base font-bold text-accent-900">引爆点提示</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-accent-900/85">
                08.11 的公开回应是全过程的转折，读时间线时建议先记住这一天，前后的说法会更容易对上。
              </p>
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2">
              <span className="flex items-center gap-2 font-label text-xs text-foreground-600">
                <span className="h-2.5 w-2.5 rounded-full bg-primary-500"></span> 关键节点
              </span>
              <span className="flex items-center gap-2 font-label text-xs text-foreground-600">
                <span className="h-2.5 w-2.5 rounded-full bg-accent-500"></span> 转折点
              </span>
              <span className="flex items-center gap-2 font-label text-xs text-foreground-600">
                <span className="h-2.5 w-2.5 rounded-full bg-background-400"></span> 常规节点
              </span>
            </div>
          </div>

          <ol className="relative">
            {timelineNodes.map((node, index) => (
              <li
                key={node.id}
                className="relative border-l border-background-300 pb-8 pl-6 last:pb-0 md:pl-8"
              >
                <span
                  className={`absolute left-0 top-2 h-3 w-3 -translate-x-1/2 rounded-full ${
                    dotStyles[node.level] ?? dotStyles.normal
                  }`}
                ></span>
                <Reveal delay={index * 60}>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-900">
                      {node.date}
                    </span>
                    <span className="font-label text-xs text-foreground-500">{node.phase}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {node.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}